import { CustomSelectChoice } from '@app/api';

export const hasCustomSelectChoice = (
  refs: string[],
  customChoice?: CustomSelectChoice,
) => {
  if (!refs) {
    return false;
  }
  if (!customChoice) {
    return (
      Object.values(CustomSelectChoice).filter((custom) =>
        refs.includes(custom),
      ).length > 0
    );
  }
  return refs.filter((ref) => ref === customChoice).length > 0;
};
